import React from 'react'
import { Card, Flex, Button, usePrevious } from '@fareye/ui'
import { IFormInputConfig, IFormConfig, IFormBuilderState } from '..'
import { GenerateRowElement } from './GenerateRowElement'
import { FormikProps } from 'formik'
import { Header } from './Header'
import { isEqual } from '@fareye/utils'
import { differenceBetweenObjects } from '../utility/funcs'
import { Row } from '../styled/styled'
import { useTranslation } from '@fareye/common'

interface ICustomForm {
  formConfig: IFormBuilderState
  baseUrl: string
  config: IFormConfig
  formikProps: FormikProps<any>
  formGroupName: string
  isLoading: boolean | undefined
  onFieldChange?: (val: any) => void
  onSpecificKeyChange?: (val: any) => void
  buttonComponent?: React.ReactElement<any>
  disableSubmit: boolean
  setDisableSubmit: (val: any) => void
  showTimezone?: boolean
  onReset?: (resetForm: () => void) => void
}
export function CustomForm({
  formConfig,
  baseUrl,
  config,
  formikProps,
  formGroupName,
  isLoading,
  onFieldChange,
  onSpecificKeyChange,
  buttonComponent,
  disableSubmit,
  setDisableSubmit,
  showTimezone,
  onReset
}: ICustomForm) {
  const { btnConfig } = config
  const previousState = usePrevious(formikProps.values)
  const { t } = useTranslation()
  React.useEffect(() => {
    onFieldChange && onFieldChange(formikProps)
    if (!isEqual(previousState, formikProps.values)) {
      const diffState = differenceBetweenObjects(
        formikProps.values,
        previousState
      )
      onSpecificKeyChange && onSpecificKeyChange({ diffState, formikProps })
    }
  }, [formikProps.values])

  return (
    <Card variant="s">
      <Header
        {...config}
        disableSubmit={disableSubmit}
        setDisableSubmit={setDisableSubmit}
      />
      {Object.keys(formConfig.rowColumnConfig).map(
        (ele: string, index: number) => {
          return (
            <Row
              key={`row${index}`}
              style={formConfig.rowColumnConfig[ele].style}
            >
              {formConfig.rowColumnConfig[ele].data.map(
                (rowElement: IFormInputConfig, secondIndex: number) => {
                  const isHidden = rowElement?.isHidden
                  return (
                    <React.Fragment key={`column${index}${secondIndex}`}>
                      {isHidden ? null : (
                        <GenerateRowElement
                          rowElement={rowElement}
                          formikProps={formikProps}
                          count={formConfig.rowColumnConfig[ele].data.length}
                          formGroup={formGroupName}
                          styles={rowElement.styles ? rowElement.styles : {}}
                          elePosition={secondIndex}
                          baseUrl={baseUrl}
                          showTimezone={showTimezone}
                        />
                      )}
                    </React.Fragment>
                  )
                }
              )}
            </Row>
          )
        }
      )}
      {
        <Flex justifyContentFlexEnd>
          {buttonComponent}
          <Button
            disabled={!formikProps.isValid || disableSubmit}
            variant="m primary"
            onClick={formikProps.handleSubmit}
            type="submit"
            style={
              btnConfig
                ? {
                    ...btnConfig.submitButton.style,
                    marginRight: '20px',
                    display: btnConfig.submitButton.isDisplay ? '' : 'none'
                  }
                : { marginRight: '20px' }
            }
            isLoading={isLoading}
          >
            {btnConfig ? t(btnConfig.submitButton.label) : t('Submit')}
          </Button>
          <Button
            variant="m danger"
            onClick={() => { onReset && onReset(formikProps.resetForm); formikProps.handleReset() }}
            type="button"
            style={
              btnConfig
                ? {
                    ...btnConfig.resetButton.style,
                    marginRight: '20px',
                    display: btnConfig.resetButton.isDisplay ? '' : 'none'
                  }
                : { marginRight: '20px' }
            }
          >
            {btnConfig ? t(btnConfig.resetButton.label) : t('Reset')}
          </Button>
        </Flex>
      }
    </Card>
  )
}
